export const ACTION_TYPES = {
  SET_SEPARATE_PROTEIN_PREDICTIONS: "SET_SEPARATE_PROTEIN_PREDICTIONS",
};

export const setSeparateProteinPredictions = (data) => ({
  type: ACTION_TYPES.SET_SEPARATE_PROTEIN_PREDICTIONS,
  payload: data,
});
